import { createFlowTransitionFunction } from '@polyai/stream/store/reducers/flows';

import type { TransitionModalFormValues } from 'components/molecules/Transitions/TransitionModalForm';
import TransitionModalForm from 'components/molecules/Transitions/TransitionModalForm';
import { useServerDispatch } from 'components/organisms/AgentStream/context/AgentStreamContext';
import { generateTransitionId } from 'lib/prettyUuid';
import { getDefaultTransition } from 'screens/FlowDetails/hooks/helpers';
import useFlowDetailsStore from 'screens/FlowDetails/hooks/useFlowDetailsStore';
import useFlowState from 'screens/FlowDetails/hooks/useFlowState';

interface TransitionPopupProps {
  onCreate?: (transition: { id: string }) => void;
  onCancel?: (reason?: string) => void;
}

export const TransitionPopup = ({
  onCreate,
  onCancel,
}: TransitionPopupProps) => {
  const { flowId } = useFlowState();
  const serverDispatch = useServerDispatch();
  const { activeStepId } = useFlowDetailsStore();

  const handleCreate = ({
    transitionName,
    toStepName,
  }: TransitionModalFormValues) => {
    const id = generateTransitionId();
    const transition = getDefaultTransition({
      id,
      transitionName,
      toStepName,
      fromStepId: activeStepId,
    });
    void serverDispatch(
      createFlowTransitionFunction({
        flowId,
        transitionFunction: transition,
      }),
    );

    if (!transition) {
      return;
    }

    onCreate?.(transition);
  };

  return (
    <TransitionModalForm
      open
      withStepSelect
      onClose={() => onCancel?.()}
      onSubmit={handleCreate}
    />
  );
};
